if (!window.Eurus || !window.Eurus.loadedScript) {
  window.Eurus = window.Eurus || {};
  window.Eurus.loadedScript = window.Eurus.loadedScript || new Set();
}

if (!window.Eurus.loadedScript.has('cart-rewards-points.js')) {
  window.Eurus.loadedScript.add('cart-rewards-points.js');

  let priceObserver = null;
  let cartDrawerObserver = null;
  let isUpdating = false;

  const tierMultipliers = {
    gold: 2,
    silver: 1.5,
    bronze: 1
  };

  const updateCartRewardsPoints = () => {
    isUpdating = true;

    let rewardsContainer = document.querySelector('.rewards-points-container');
    let totalPriceEl = document.querySelector('#total-price');
    let totalPointsEl = document.querySelector('#totalPoints');
    let convertedPointsEl = document.querySelector('#convertedPoints');
    let isMainCart = false;

    if (!rewardsContainer || !totalPriceEl || !totalPointsEl || !convertedPointsEl) {
      rewardsContainer = document.querySelector('.rewards-content');
      totalPriceEl = document.querySelector('#main-cart-total-price');

      const desktopRewards = document.querySelector('.main-cart-footer_items .rewards-content');
      const mobileRewards = document.querySelector('.mobile-cart-checkout .rewards-content');

      const isDesktopVisible = desktopRewards && desktopRewards.offsetParent !== null;
      const isMobileVisible = mobileRewards && mobileRewards.offsetParent !== null;

      if (isDesktopVisible) {
        totalPointsEl = desktopRewards.querySelector('#mainCartTotalPoints');
        convertedPointsEl = desktopRewards.querySelector('#mainCartConvertedPoints');
      } else if (isMobileVisible) {
        totalPointsEl = mobileRewards.querySelector('#mainCartTotalPoints');
        convertedPointsEl = mobileRewards.querySelector('#mainCartConvertedPoints');
      }

      isMainCart = true;
    }

    if (!rewardsContainer || !totalPriceEl || !totalPointsEl || !convertedPointsEl) {
      isUpdating = false;
      return;
    }

    const customerTier = (rewardsContainer.dataset.customerTier || 'bronze').toLowerCase();
    const multiplier = tierMultipliers[customerTier] || 1;

    const priceText = totalPriceEl.textContent.trim();

    let cleanPrice = priceText.replace(/[^0-9.,]/g, '');

    const lastComma = cleanPrice.lastIndexOf(',');
    const lastDot = cleanPrice.lastIndexOf('.');

    if (lastComma > lastDot) {
      cleanPrice = cleanPrice.replace(/\./g, '').replace(',', '.');
    } else {
      cleanPrice = cleanPrice.replace(/,/g, '');
    }

    const numericPrice = parseFloat(cleanPrice);


    if (isNaN(numericPrice) || numericPrice <= 0) {
      totalPointsEl.textContent = '0';
      convertedPointsEl.textContent = '0.00';
      isUpdating = false;
      return;
    }

    const points = Math.floor(numericPrice * multiplier);

    const worth = (points / 10).toFixed(2);


    totalPointsEl.textContent = points;
    convertedPointsEl.textContent = worth;


    setTimeout(() => {
      isUpdating = false;
    }, 50);
  };

  const setupPriceObserver = () => {
    let totalPriceEl = document.querySelector('#total-price');
    let cartType = 'side-cart';

    if (!totalPriceEl) {
      totalPriceEl = document.querySelector('#main-cart-total-price');
      cartType = 'main-cart';
    }

    if (!totalPriceEl) {
      return;
    }

    if (priceObserver) {
      priceObserver.disconnect();
    }


    updateCartRewardsPoints();

    priceObserver = new MutationObserver(() => {
      if (isUpdating) return;
      updateCartRewardsPoints();
    });

    priceObserver.observe(totalPriceEl, {
      childList: true,
      subtree: true,
      characterData: true
    });
  };

  const initCartRewardsPoints = () => {

    const cartDrawer = document.querySelector('#CartDrawer');
    const mainCartItems = document.querySelector('#main-cart-items');
    let rewardsContainer = document.querySelector('.rewards-points-container');
    let containerToObserve = cartDrawer;
    let cartType = 'side-cart';

    if (!rewardsContainer) {
      rewardsContainer = document.querySelector('.rewards-content');
      containerToObserve = mainCartItems;
      cartType = 'main-cart';
    }

    if (!containerToObserve) {
      return;
    }

    if (!rewardsContainer) {
      return;
    }


    setupPriceObserver();

    if (cartDrawerObserver) {
      cartDrawerObserver.disconnect();
    }

    cartDrawerObserver = new MutationObserver((mutations) => {
      if (isUpdating) {
        return;
      }

      for (const mutation of mutations) {
        if (mutation.addedNodes.length > 0 || mutation.type === 'childList') {
          const hasSideCartPrice = document.querySelector('#total-price');
          const hasMainCartPrice = document.querySelector('#main-cart-total-price');
          const hasSideCartRewards = document.querySelector('.rewards-points-container');
          const hasMainCartRewards = document.querySelector('.rewards-content');

          if ((hasSideCartPrice && hasSideCartRewards) || (hasMainCartPrice && hasMainCartRewards)) {
            setTimeout(() => {
              setupPriceObserver();
            }, 100);
            break;
          }
        }
      }
    });

    cartDrawerObserver.observe(containerToObserve, {
      childList: true,
      subtree: true
    });

  };

  const tryInit = (attempts = 0) => {
    const maxAttempts = 10;

    let rewardsContainer = document.querySelector('.rewards-points-container');
    let totalPriceEl = document.querySelector('#total-price');

    if (!rewardsContainer || !totalPriceEl) {
      rewardsContainer = document.querySelector('.rewards-content');
      totalPriceEl = document.querySelector('#main-cart-total-price');
    }

    if (rewardsContainer && totalPriceEl) {
      initCartRewardsPoints();
    } else if (attempts < maxAttempts) {
      setTimeout(() => tryInit(attempts + 1), 300);
    } else {
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => tryInit());
  } else {
    tryInit();
  }

  document.addEventListener('cart:updated', () => {
    setTimeout(() => tryInit(), 200);
  });

  document.addEventListener('cart:refresh', () => {
    setTimeout(() => tryInit(), 200);
  });

  document.addEventListener('cart:open', () => {
    setTimeout(() => tryInit(), 200);
  });

  window.addEventListener('alpine:init', () => {
    if (window.Alpine && window.Alpine.store) {
    }
  });
}
